import React from 'react';
import { Car, Bank, CklockRotate, AddressBook, FileLines, Truck, Building } from '../../../../components/Icon';

export const StepperIcons = function(props) {
  if (props.step === 1 && props.model === 'vehicle') {
    return (
      <>
        <Car />
        {props.label}
      </>
    );
  }

  if (props.step === 2 && props.model === 'vehicle') {
    return (
      <>
        <Bank />
        {props.label}
      </>
    );
  }

  if (props.step === 3 && props.model === 'vehicle') {
    return (
      <>
        <CklockRotate />
        {props.label}
      </>
    );
  }

  if (props.step === 4 && props.model === 'vehicle' && !props.edit) {
    return (
      <>
        <FileLines />
        {props.label}
      </>
    );
  }

  if (props.step === 4 && props.model === 'vehicle' && props.edit) {
    return (
      <>
        <AddressBook />
        {props.label}
      </>
    );
  }

  if (props.step === 5 && props.model === 'vehicle' && props.edit) {
    return (
      <>
        <FileLines />
        {props.label}
      </>
    );
  }

  if (props.step === 5 && props.model === 'vehicle' && !props.edit) {
    return (
      <>
        <Truck />
        {props.label}
      </>
    );
  }

  if (props.step === 6 && props.model === 'vehicle' && props.edit) {
    return (
      <>
        <Truck />
        {props.label}
      </>
    );
  }

  if (props.step === 1 && props.model === 'company') {
    return (
      <>
        <Building />
        {props.label}
      </>
    );
  }
  if (props.step === 2 && props.model === 'company') {
    return (
      <>
        <Bank />
        {props.label}
      </>
    );
  }
  if (props.step === 3 && props.model === 'company') {
    return (
      <>
        <AddressBook />
        {props.label}
      </>
    );
  }
  if (props.step === 4 && props.model === 'company') {
    return (
      <>
        <Truck />
        {props.label}
      </>
    );
  }
  return (
    <>
      <p>Somthing went wrong</p>
    </>
  );
};
